import {myChannelsApi} from '@/api/my-channels.api.js'
import {ref} from 'vue'

/**
 * Channel management composable
 */
export function useChannelManagement(channel) {

  //Updating channel flag
  const isUpdatingChannel = ref(false)

  //Update unread state
  const updateIsUnread = async isUnread => {

    //Must have channel with ID
    if (!channel.value?.id) {
      throw new Error(`Must have channel with ID`)
    }

    //Extract ID
    const {id} = channel.value

    //Toggle flag
    isUpdatingChannel.value = true

    //Update
    try {
      await myChannelsApi.updateById(id, {isUnread})
    }
    finally {
      isUpdatingChannel.value = false
    }
  }

  //Expose interface
  return {
    updateIsUnread,
    isUpdatingChannel,
  }
}
